import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { isEmpty } from 'lodash';
import { validators } from '../../utils/validators';
import { FormElems, Alert } from '../../components';

const DownloadFile = props => {
    const {
        actions,
        filterData,
        showDownloadPopup,
        setShowDownloadPopup,
        tableData,
        handleSubmit,
        untouch,
        change,
        generateData,
        handleViewDownloads,
    } = props;
    const handleOpenActionPopup = actionType => {
        setShowDownloadPopup(!showDownloadPopup);
    };

    useEffect(() => {
        if (generateData.isSuccess) {
            change('fileName', '');
            untouch('downloadFile', 'fileName');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generateData.isSuccess]);

    const handleCloseOpenActionPopup = () => {
        setShowDownloadPopup(false);
        change('fileName', '');
        untouch('downloadFile', 'fileName');
    };

    const handleGenerateSubmit = values => {
        actions.generateReportRequest({
            reportFileName: values.fileName,
            ...filterData,
            handleViewDownloads,
        });
    };
    useEffect(() => {
        return () => {
            handleCloseOpenActionPopup();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    console.log('filterData', tableData, filterData);
    return (
        <div className={'payment-page'}>
            <div className="download-popup">
                <button className={`download ${showDownloadPopup ? 'active' : ''}`} onClick={handleOpenActionPopup} />
                {showDownloadPopup ? (
                    <>
                        <div className="overlay" onClick={handleCloseOpenActionPopup} />
                        <div className="popup-download">
                            <div className="content-body">
                                <form className="popup-download-edit" onSubmit={handleSubmit(handleGenerateSubmit)}>
                                    <div className="form-section">
                                        <div className="form-field">
                                            <p className="label">Enter any name for download file</p>
                                            <Field
                                                name="fileName"
                                                type="text"
                                                component={FormElems.Input}
                                                placeholder="Enter File Name"
                                            />
                                        </div>
                                    </div>
                                    {/* eslint-disable-next-line no-nested-ternary */}
                                    {isEmpty(filterData.createdOn) ? (
                                        <Alert customClass="error-msg">Please select a data range</Alert>
                                    ) : isEmpty(tableData) ? (
                                        <Alert customClass="error-msg">No data available</Alert>
                                    ) : null}
                                    <div className="form-section action">
                                        <FormElems.Button
                                            buttonType="primary"
                                            text="Generate"
                                            isDisable={isEmpty(tableData) || isEmpty(filterData.createdOn)}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};

DownloadFile.propTypes = {
    actions: PropTypes.object,
    filterData: PropTypes.object,
    tableData: PropTypes.object,
    showDownloadPopup: PropTypes.bool,
    setShowDownloadPopup: PropTypes.func,
    handleSubmit: PropTypes.func,
    change: PropTypes.func,
    untouch: PropTypes.func,
    generateData: PropTypes.object,
    handleViewDownloads: PropTypes.func,
};

const validate = values => {
    const { REQUIRED } = validators;
    const errors = {};

    if (REQUIRED(values) || REQUIRED(values.fileName)) {
        errors.fileName = 'Please enter a File Name';
    }
    if (values.fileName && values.fileName.length > 25) {
        errors.fileName = 'Max 25 character are allowed in filename';
    }
    const isValid = /^[A-Za-z0-9\d\-_\s]+$/i.test(values.fileName);
    if (!isValid) {
        errors.fileName = 'Only numbers, letters, - & _ are allowed in filename';
    }
    if (!/^\S+$/.test(values.fileName)) {
        errors.fileName = 'Spaces not allowed in filename';
    }
    return errors;
};

export default reduxForm({
    form: 'downloadFile',
    enableReinitialize: true,
    validate,
    destroyOnUnmount: false,
})(DownloadFile);
